// extracted by mini-css-extract-plugin
module.exports = {"inlineEdit":"inlineedit_inlineEdit__1ARsD","inlineEditDisabled":"inlineedit_inlineEditDisabled__6YdzY"};